export default "__VITE_ASSET__DT963JlD__"